import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'

Vue.config.productionTip = false

// --- GET HOSTS ---
let socketServerIP = process.env.VUE_APP_SOCKET_SERVER_HOST;

if (process.env.VUE_APP_HYBRID == "true" && process.env.VUE_APP_ANDROID_APP === "false") {
  if (window.location.hostname !== 'localhost' && window.location.hostname !== 'pickupmon.3pos.de' && window.location.hostname !== 'pickupmon.testing.3pos.de') {
    socketServerIP = location.protocol + "//" + window.location.hostname + ":8025";
  }
}

// --- Socket.io ---
import VueSocketIO from 'vue-socket.io';

Vue.use(new VueSocketIO({
  debug: true,
  options: {
    autoConnect: false
  },
  connection: socketServerIP
}));

new Vue({
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')